export const TableRenderEnum = {
  APPLICATIONS: 'AppsCellRenderer',
  CHECKBOX: 'CheckboxCellRenderer',
  DATE: 'DateCellRenderer',
  DEFAULT: 'DefaultCellRenderer',
  DATA_SIZE: 'DataSizeCellRenderer',
  NUMBER_FORMAT: 'NumberFormatCellRenderer',
  DOT: 'DotCellRenderer',
  ICON: 'IconCellRenderer',
  ICON_IMAGE: 'IconImageCellRenderer',
  LABEL: 'LabelIconRenderer',
  LINK: 'LinkCellRenderer',
  PATH: 'PathCellRenderer',
  PERCENTAGE: 'PercentageCellRenderer',
  PROGRESS_BAR: 'ProgressBarCellRenderer',
  STATUS: 'StatusCellRenderer',
  STRING: 'StringCellRenderer',
  TIME: 'TimeCellRenderer',
  NUMBER: 'NumberCellRenderer',
  // MINI_CHART: 'MiniChartCellRenderer',
  // COMPARISON: 'ComparisonCellRenderer',
  HARD_ICU_DAYS: 'IcuDaysCellStyle',
  DOT_MENU: 'DotMenuCellRenderer',
  CLICK_EDIT: 'ClickEditRenderer',
  DELETE_ICON: 'DeleteIconRenderer',
  BUTTON_TEXT: 'ButtonTextCellRenderer',
  TOGGLE: 'ToggleRenderer',
  MORE_ACTIONS: 'MoreActionsRenderer',
};

export interface TableOptions {
  columnDefs: InsColumnDef[];
  data: any[];
}

export interface InsColumnDef {
  id?: number;
  headerName: string;
  field: string;
  cellRenderer?: string;
  cellRendererParams?: any;
  filterType?: string;
  filterUnit?: string;
  filterFromUnit?: string;
  filterToUnit?: string;
  filterDecimals?: number;
  icons?: object;
  sort?: 'desc' | 'asc';
  disableSorting?: boolean;
  disableDrag?: boolean;
}

export enum InsSelectionType {
  none = 'none', // No selection.
  single = 'single', // Single selection; a radio button will be added for each row.
  multiple = 'multiple', // Multiple selections; a checkbox will be added for each row.
}
